import { Component } from 'react';
import PropTypes from 'prop-types';

import Translations from '../../utils/Translations';
import ActorChatRatingPropType from './ActorChatRatingPropType';
import './../../../../src/VX/Asset/Less/Base/vendor/tooltip.less';

class CustomerSatisfaction extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isTooltipVisible: false,
		};

		this.onShowInfo = this.onShowInfo.bind(this);
		this.onCloseTooltipButton = this.onCloseTooltipButton.bind(this);
	}

	onShowInfo() {
		this.setState({
			isTooltipVisible: true,
		});
	}

	onCloseTooltipButton() {
		this.setState({
			isTooltipVisible: false,
		});
	}

	render() {
		if (!this.props.rating) {
			return null;
		}

		const chatRating = this.props.rating;
		const baseClass = 'actor-customer-satisfaction';
		const shouldShowTooltip = 'tooltip-' + (this.state.isTooltipVisible ? 'shown' : 'hidden');
		const satisfactionRate = (chatRating.satisfactionRate * 100).toFixed(0);
		return (
			<div className={baseClass + (this.props.isMobile ? ' -is-mobile' : '')}>
				<span className={`${baseClass}-rating-label`}>
					<div>
						{this.state.isTooltipVisible && <div className={`${baseClass}-tooltip__backdrop`} onClick={this.onCloseTooltipButton} />}
						{chatRating.countRatings} {Translations.get('ActorProfileChatRatingLabel')}
					</div>

					<div className={`${baseClass}-rating-label-info`}>
						<i className={`icon -icon-round-info-line`} onClick={this.onShowInfo} />
						<div className={`${baseClass}-tooltip ${shouldShowTooltip}`}>
							<i className={`${baseClass}-tooltip-close icon -icon-close-full`} onClick={this.onCloseTooltipButton} />
							<div className={`${baseClass}-tooltip-title`}>{Translations.get('ActorProfileChatRatingTitle')}</div>
							<div className={`${baseClass}-tooltip-description`}>{Translations.get('ActorProfileChatRatingDescription')}</div>
							<div className={`${baseClass}-tooltip-pointer`} />
						</div>
					</div>
				</span>
				<span className={`${baseClass}-rating-progress`}>
					<i className={`${baseClass}-rating-progress-like icon -icon-like-full`} />
					<span className={`${baseClass}-rating-progress-value`}>{satisfactionRate}%</span>
					<div className={`${baseClass}-rating-progress-bar`}>
						<div className={`${baseClass}-rating-progress-bar-filler`} style={{ width: satisfactionRate + '%' }} />
					</div>
				</span>
			</div>
		);
	}
}

CustomerSatisfaction.propTypes = {
	actorId: PropTypes.number.isRequired,
	isMobile: PropTypes.bool,
	rating: ActorChatRatingPropType,
};

CustomerSatisfaction.defaultProps = {
	isMobile: false,
	rating: null,
};

export default CustomerSatisfaction;
